export default __webpack_public_path__ + "static/media/card2.27be9687.png";